import React from 'react';

function ResetPasswordWithTokenDialogHeader() {
  return (
    <div className="reset-password-with-token-dialog__header">
      <h4>Reset Password</h4>
    </div>
  );
}

export default ResetPasswordWithTokenDialogHeader;
